import objectHash from "object-hash";
import { diffJson } from 'diff';

/**
 * Check whether an action will change state redux state. Returns `true` if action will result in a changed state.
 * 
 * @param {*} state the current scoped redux state (portion of state from a single reducer, NOT the root redux state)
 * @param {*} action the action being done scoped redux state
 * @param {*} reducer the reducer function that takes the passed state and action
 * @param {*} logger the logger function that the diff string
 * @returns boolean
 */
export const didStoreDataChange = (state = {}, action, reducer, logger) => {
  const prevState = JSON.parse(JSON.stringify(state));
  const newState = JSON.parse(JSON.stringify(reducer(state, action)));
  const prevHash = objectHash(prevState);
  const newHash = objectHash(newState);
  const didChange = prevHash !== newHash;
  
  if(didChange) {
    const diff = diffJson(prevState, newState).filter(({ added, removed }) => added || removed);
    logger?.(JSON.stringify(diff))
  }
  
  return prevHash !== newHash;
}